<template>
    <a-modal :title="titlePrefix" :visible="visible" centered :destroy-on-close="true" :mask-closable="false"
             :confirm-loading="confirmLoading" @ok="onSubmit" @cancel="onClose" wrap-class-name="single-spa-vue">
        <a-form ref="ruleForm" layout="vertical" :model="form" :rules="rules" @submit="onSubmit">
            <!--可编辑区域 start-->
            <div class="hidden">
                <a-form-item label="undefined" name="menuId">
                    <a-input v-model:value="form.menuId" placeholder="请输入undefined"/>
                </a-form-item>
                <a-form-item label="undefined" name="parentId">
                    <a-input v-model:value="form.parentId" placeholder="请输入undefined"/>
                </a-form-item>
            </div>
            <a-form-item label="功能编码" name="menuCode">
                <a-input v-model:value="form.menuCode" placeholder="请输入功能编码"/>
            </a-form-item>
            <a-form-item label="功能名称" name="menuName">
                <a-input v-model:value="form.menuName" placeholder="请输入功能名称"/>
            </a-form-item>
            <a-form-item label="请求路径" name="url">
                <a-textarea v-model:value="form.url" placeholder="请输入请求路径" :auto-size="{minRows:3,maxRows:6}"/>
            </a-form-item>
            <a-form-item label="请求路径类型" name="urlType">
                <a-radio-group v-model:value="form.urlType">
                    <a-radio :value="1">页面</a-radio>
                    <a-radio :value="2">数据</a-radio>
                </a-radio-group>
            </a-form-item>
            <a-form-item label="排序" name="sort">
                <a-input-number v-model:value="form.sort" :min="0" :precision="0"/>
            </a-form-item>
            <a-form-item label="描述" name="description">
                <a-textarea v-model:value="form.description" placeholder="请输入描述" :auto-size="{minRows:3,maxRows:6}"/>
            </a-form-item>
            <!--可编辑区域 end-->
        </a-form>
    </a-modal>
</template>
<script>
import dataCheck from "@/utils/dataCheck";
import {formMixin} from "@/mixins";
import {sys_menu} from "@/api/adminService";

export default {
    name: "MenuListModal",
    mixins: [formMixin],
    components: {},
    data() {
        return {
            form: {
                menuId: null,
                parentId: null,
                menuCode: null,
                menuName: null,
                url: null,
                urlType: null,
                sort: null,
                description: null,
            },
            rules: {
                menuId: [],
                parentId: [
                    dataCheck.required({}),
                ],
                menuCode: [
                    dataCheck.required({}),
                    dataCheck.remote({
                        url: sys_menu.verifyMenuCode,
                        fieldName: 'menuCode',
                        fnSetParam: () => {
                            return {
                                menuId: this.form.menuId
                            }
                        }
                    })
                ],
                menuName: [
                    dataCheck.required({}),
                ],
                url: [
                    dataCheck.required({}),
                ],
                urlType: [
                    dataCheck.required({type: 'number'}),
                ],
                sort: [
                    dataCheck.required({type: 'number'}),
                ],
                description: [],
            },
            submitUrl: sys_menu.methodSaveOrUpdateOrOpen
        }
    },
    methods: {},
}
</script>
<style scoped lang="less">
</style>
